import React from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';
import ContactForm from './ContactForm';

function Contact() {
  const { t } = useTranslation('common');

  return (
    <div className="Contact">
      <h1 className="title">{t('navigation.contact', 'Contact us')}</h1>
      <div className="ContactFormContainer">
        <ContactForm />
      </div>
    </div>
  );
}

export default Contact;
